import React from 'react';
import styled from 'styled-components';
import { color } from '@starrez/starryui9';

export interface IFooterComponentProps {
    onHide: () => void;
    onShow: () => void;
}

export interface IFooterProps {
    Component: React.FC<IFooterComponentProps>;
    componentProps?: any;
}

export const Footer = ({ Component, componentProps }: IFooterProps) => {
    const [show, setShow] = React.useState(false);

    return (
        <StyledFooter style={{ visibility: show ? 'visible' : 'hidden' }}>
            <Contents>
                <Component {...componentProps} onHide={() => setShow(false)} onShow={() => setShow(true)} />
            </Contents>
        </StyledFooter>
    );
};

const Contents = styled.div`
    position: sticky;
    left: 16px;
    display: inline-block;
`;

const StyledFooter = styled.footer`
    position: sticky;
    bottom: 0;
    background: ${color.Grey.G10};
    height: 56px;
    padding: 4px 16px;
`;
